import { Link, Outlet, createFileRoute } from '@tanstack/react-router'
import { ProgressBar } from '@/components/progress-bar'
import { ToolsFooter } from '@/components/tools-footer'
import { ToolsNotFound } from '@/components/tools-not-found'
import { BackgroundPattern } from '@/components/ui/background-pattern'
import { Logo } from '@/components/ui/logo'

export const Route = createFileRoute('/$locale/tools')({
  notFoundComponent: () => <ToolsNotFound />,
  component: ToolsLayout,
})

function ToolsLayout() {
  const { locale } = Route.useParams()

  return (
    <div className="tools-theme relative min-h-screen w-full">
      <ProgressBar />
      <BackgroundPattern />
      <div className="flex flex-col items-center min-h-screen">
        <Link
          to={'/$locale' as never}
          params={{ locale } as never}
          className="mt-8 mb-4 md:mt-12"
          aria-label="CountAct"
        >
          <Logo size="xs" />
        </Link>
        <main className="w-full max-w-2xl flex-1">
          <Outlet />
        </main>
        <ToolsFooter />
      </div>
    </div>
  )
}
